// This import loads the firebase namespace along with all its type information.
import SquadMate from './squad-mate-model'

export async function load_squadMates(): Promise<SquadMate[]> {
  throw 'Not implemented'
}

export async function delete_squadMate(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_squadMate(): Promise<SquadMate> {
  throw 'Not implemented'
}
